// extracted by mini-css-extract-plugin
export default {"layout_loggedin":"styles_layout_loggedin__1zPXz","footer":"styles_footer__uvItH"};